import { render, staticRenderFns } from "./StaffHeader.vue?vue&type=template&id=1a2fea3e&scoped=true"
import script from "./StaffHeader.vue?vue&type=script&lang=js"
export * from "./StaffHeader.vue?vue&type=script&lang=js"
import style0 from "./StaffHeader.vue?vue&type=style&index=0&id=1a2fea3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2fea3e",
  null
  
)

export default component.exports